// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { UserManagerSettings } from "oidc-client";
import { AppSettings } from "./appSettings";

export interface OidcSettings extends UserManagerSettings {
  response_type: string;
  scope: string;
  automaticSilentRenew: boolean;
  authority: string;
  client_id: string;
  redirect_uri: string;
  silent_redirect_uri: string;
  post_logout_redirect_uri: string;
}
/**
 * Gets the OIDC settings for the Mobi Identity server
 * @returns {object} Settings
 */
export default function buildOidcSettings(appSettings: AppSettings): OidcSettings {
  const settings: any = {};
  settings.response_type = "code";
  settings.scope = "openid email profile mobicrm IdentityServerApi offline_access";
  settings.automaticSilentRenew = true;
  settings.authority = appSettings.IDENTITY_URL;
  settings.client_id = appSettings.CLIENT_ID;

  settings.redirect_uri = window.location.origin + "/oidc-callback.html";
  settings.silent_redirect_uri = window.location.origin + "/oidc-silent-renew.html";
  settings.post_logout_redirect_uri = window.location.origin + "/index.html";
  return settings;
}
